export const MEAT_TYPES = [
  { id: 1, nameKey: 'constants.meatTypes.beef' },
  { id: 2, nameKey: 'constants.meatTypes.pork' },
  { id: 3, nameKey: 'constants.meatTypes.chicken' }
] as const;

export const SUPPLIER_TYPES = [
  { value: '', labelKey: 'constants.supplierTypes.all' },
  { value: 'NEW_SUPPLIER', labelKey: 'constants.supplierTypes.new' },
  { value: 'HISTORICAL_SUPPLIER', labelKey: 'constants.supplierTypes.historical' }
] as const;

export const APPLICATION_STATUSES = [
  { value: '', labelKey: 'constants.applicationStatuses.all' },
  { value: 'PENDING', labelKey: 'constants.applicationStatuses.pending' },
  { value: 'APPROVED', labelKey: 'constants.applicationStatuses.approved' },
  { value: 'REJECTED', labelKey: 'constants.applicationStatuses.rejected' },
  { value: 'UNDER_CONSIDERATION', labelKey: 'constants.applicationStatuses.underConsideration' },
  { value: 'ALLOCATED', labelKey: 'constants.applicationStatuses.allocated' },
  { value: 'QUOTA_REVOKED', labelKey: 'constants.applicationStatuses.revoked' }
] as const;

export const DISTRIBUTION_TABS = [
  { value: 'all', labelKey: 'constants.distributionTabs.all' },
  { value: 'stage1', labelKey: 'constants.distributionTabs.stage1' },
  { value: 'stage2', labelKey: 'constants.distributionTabs.stage2' },
  { value: 'new_suppliers', labelKey: 'constants.distributionTabs.newSuppliers' },
  { value: 'remainder', labelKey: 'constants.distributionTabs.remainder' }
] as const;

export const MEAT_TYPE_TABS = [
  { value: 'all', labelKey: 'constants.meatTypeTabs.all' },
  { value: 'beef', labelKey: 'constants.meatTypeTabs.beef' },
  { value: 'chicken', labelKey: 'constants.meatTypeTabs.chicken' },
  { value: 'pork', labelKey: 'constants.meatTypeTabs.pork' },
  { value: 'withdrawn', labelKey: 'constants.meatTypeTabs.withdrawn' }
] as const;
